import {
  ButtonGroup,
  UploadImage,
  UploadImageValue,
  UploadedFileFormatIsNotAllowedBySpecifiedAcceptedField,
  closeCurrentDialog,
  showNotification,
} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useUploadFileMutation} from '@dms/api/base';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface UploadAvatarProps extends RequiredTestIdProps {
  handleUpload: (image: UploadImageValue) => void;
}

export function UploadAvatar(props: UploadAvatarProps) {
  const [uploadFile] = useUploadFileMutation();

  const handleUpload = async (file: File) => {
    const data = await uploadFile({file}).unwrap();

    return {id: data.fileId, url: data.fileUri};
  };

  const handleUploadError = (error: Error) => {
    if (error instanceof UploadedFileFormatIsNotAllowedBySpecifiedAcceptedField) {
      showNotification.error(i18n.t('entity.watermark.notifications.imageFormatIsNotAllowed'));
    }
  };

  return (
    <VStack spacing={4}>
      <UploadImage
        uploadFileRequest={handleUpload}
        onChange={(file) => {
          if (!file) {
            return;
          }

          props.handleUpload({id: file.id, url: file.url});
        }}
        onUploadError={handleUploadError}
        value={null}
        size="minHeight"
        aspectRatio="1/1"
        data-testid={suffixTestId('upload-image', props)}
      />

      <ButtonGroup
        align="right"
        buttons={[
          {
            title: i18n.t('general.actions.discard'),
            variant: 'secondary',
            onClick: closeCurrentDialog,
          },
        ]}
      />
    </VStack>
  );
}
